import { apiClient } from './client'

export type Machine = {
  machine: string
  marque: string
  remarque: string
}

export type DemandeEnlevement = {
  validation_token: string
  nom: string
  adresse?: string
  code_postal?: string
  localite?: string
  telephone1?: string
  telephone2?: string
  email?: string
  numero_client?: string
  machines: Machine[]
  remarque_generale?: string
}

export async function envoyerDemande(d: DemandeEnlevement): Promise<{ message: string; id: number; numero_demande: number }> {
  const { data } = await apiClient.post('/api/enlevement', d)
  return data
}

// ── Étape 1 : code personnel ──

export type Prefill = {
  numero_client?: string
  nom?: string
  adresse?: string
  code_postal?: string
  localite?: string
  telephone1?: string
  telephone2?: string
  email?: string
}

export async function verifyCode(code: string): Promise<{ prefill: Prefill; validation_token: string }> {
  const { data } = await apiClient.post<{ prefill: Prefill; validation_token: string }>('/api/enlevement/verify-code', { code })
  return data
}

/** Un créneau par machine : « Machine1_Type » … « Machine6_Type ». Ouvert,
 *  et non trois champs nommés — c'est en les écrivant à la main qu'on avait
 *  oublié les machines 4 à 6. */
export type MachineTypes = Record<string, string[]>

export async function getMachineTypes(): Promise<MachineTypes> {
  const { data } = await apiClient.get<{ types: MachineTypes }>('/api/enlevement/machine-types')
  return data.types
}

export async function getMachineMarques(type: string): Promise<string[]> {
  const { data } = await apiClient.get<{ marques: string[] }>('/api/enlevement/machine-marques', {
    params: { type },
  })
  return data.marques
}

// ── Admin ──

export type DemandeRow = {
  id: number
  numero_demande?: string | null
  nom: string
  adresse?: string
  code_postal?: string
  localite?: string
  telephone1?: string
  telephone2?: string
  email?: string
  numero_client?: string
  machines: Machine[]
  remarque_generale?: string
  traite: boolean
  created_at: string
}

export async function listDemandes(): Promise<DemandeRow[]> {
  const { data } = await apiClient.get<DemandeRow[]>('/api/enlevement')
  return data
}

export async function setTraite(id: number, traite: boolean): Promise<void> {
  await apiClient.put(`/api/enlevement/${id}/traite`, null, { params: { traite } })
}

export type EnlevementConfig = { config: Record<string, string>; nb_clients: number }

export async function getEnlevementConfig(): Promise<EnlevementConfig> {
  const { data } = await apiClient.get<EnlevementConfig>('/api/enlevement/config')
  return data
}

export async function updateEnlevementConfig(valeurs: Record<string, string>): Promise<void> {
  await apiClient.put('/api/enlevement/config', { valeurs })
}
